import {DYNAMIC_FILTER_TYPE} from "../dynamic-filter/link-dynamic-filter";

const DYNAMIC_FILTER_LNK_MAP = {
    input: 'normal',
    date: 'date',
    number: 'number',
    picklist: 'picklist',
    lov: 'lov',
}

/**
 * AutoTable单字段筛选，全字段筛选，表单查询，列筛选通用筛选值
 * @author  韦胜健
 * @date    2019/9/28 9:52
 */
class LinkFilterOption {
    column;                         //列对象
    title;                          //列标题
    field;                          //字段
    type;                           //筛选类型
    externalData;                   //列额外数据
    lov;                            //列为值列表时，值列表类型
    parentLovType;                  //列为值列表时，父值列表类型
    parentLovValue;                 //列为值列表时，父值列表值

    constructor(column) {
        const {title, field, filterName, lov, externalData} = column
        Object.assign(this, {
            title, lov, externalData,
			field: column.searchField ? column.searchField : column.field,
            column,
            type: DYNAMIC_FILTER_TYPE[filterName],
            parentLovType: !!externalData ? externalData.parentLovType : null,
            parentLovValue: !!externalData ? externalData.parentLovValue : null,
        })
    }
}

/**
 * 组合筛查询选值
 * @author  韦胜健
 * @date    2019/9/28 9:53
 */
class LnkFilterOption {
    column;                         //咧对象
    field;                          //列字段
    name;                           //列名称
    defaultSearch;                  //是否为默认筛选

    /*picklist列之外的列属性*/
    lnkType;                        //筛选类型
    lov;                            //列为值列表时，值列表类型
    parentLov;                      //列为值列表时，父值列表类型
    parentLovVal;                   //列为值列表时，父值列表值

    /*picklist列所需要的属性*/
    isLink;                         //是否为object（picklist）列
    type;                           //当列为object列时，type要为picklist
    pickProps = {                   //为object列时，额外参数
        option: null,               //AutoOption
        title: null,                //表格标题
        show: false,
        disabled: false,
        showKey: null,              //显示值key
        pickMap: null,              //object列的map映射
        reverseMap: true,
        placeholder: null
    }

    constructor(column, searchField) {

        Object.assign(this, {
            column,
			field: column.searchField ? column.searchField : column.field,
            name: column.title,
            defaultSearch: searchField === column.field,
        })

        if (column.filterName === 'picklist') {
            let {option, showKey, map} = column.externalData;

            if (!option) {
                option = {}
                console.log(`列 ${column.title} 没有配置 option参数，如果希望作为普通列使用，请换成 link-table-column`)
            }

            Object.assign(this, {
                isLink: true,
                type: 'picklist',
                pickProps: {
                    option: option,
                    title: option.title,
                    show: false,
                    disabled: false,
                    showKey: showKey,
                    pickMap: map,
                    reverseMap: true,
                    placeholder: LinkVue.$t('LinkForm.selectPlaceholder')
                }
            })

            delete this.lov
            delete this.lnkType
            delete this.parentLov
            delete this.parentLovVal

        } else {
            Object.assign(this, {
                lnkType: DYNAMIC_FILTER_LNK_MAP[column.filterName],
                lov: column.lov,
                parentLov: !!column.externalData ? column.externalData.parentLovType : null,
                parentLovVal: !!column.externalData ? column.externalData.parentLovValue : null,
            })

            delete this.isLink
            delete this.type
            delete this.pickProps
        }
    }
}

const AutoTableFilter = {
    /**
     * 获取通用筛选option
     * @author  韦胜健
     * @date    2019/9/27 15:16
     */
    getLinkFilterOption(column) {
        if (column.hide) return null
        if (column.search === false && column.sort === false && column.columnFilter === false) return null
        return new LinkFilterOption(column)
    },
    /**
     * 获取组合查询所需要的filterOption
     * @author  韦胜健
     * @date    2019/9/27 15:06
     */
    getLnkFilterOption(column, searchField) {
        if (column.search === false || !!column.hide) return null
        return new LnkFilterOption(column, searchField)
    },
    /**
     * 获取快速筛选所需要的筛选参数
     * @author  韦胜健
     * @date    2019/9/27 15:18
     */
    getQuickFilterOption(column) {
        if (!column.quickFilter || !!column.hide) return null
        return {
			field: column.searchField ? column.searchField : column.field,
            name: column.title,
            lov: column.lov,
            parentLov: !!column.externalData ? column.externalData.parentLovType : null,
            parentLovVal: !!column.externalData ? column.externalData.parentLovValue : null,
            excludeLov: !!column.externalData ? column.externalData.excludeLov : null,
        }
    },
}

export {AutoTableFilter, DYNAMIC_FILTER_LNK_MAP}
